<div mat-dialog-content>
    <div>
        <h2>Update Meeting Status</h2>
    </div>
    <div class="d-flex gap-3 align-items-center justify-content-between mb-3">
        <div>{{meetingStatusQuestion}}</div>
        <mat-button-toggle-group name="fontStyle" aria-label="meeting status" [formControl]="meetingStatusControl">
            <mat-button-toggle [value]="1">Yes</mat-button-toggle>
            <mat-button-toggle [value]="0">No</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div *ngIf="meetingStatusControl.value === 1" class="d-flex flex-column gap-1">

        <mat-form-field appearance="outline">
            <mat-label>{{dateLabel}}</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="Pick Date" [formControl]="meetingDateControl" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{timeLabel}}</mat-label>
            <input matInput [ngxTimepicker]="picker1" [format]=24
                   [formControl]="meetingTimeControl" placeholder="Choose time" name="meetingTimeControl" required>
            <ngx-material-timepicker #picker1></ngx-material-timepicker>
        </mat-form-field>
    </div>
    <div class="d-flex justify-content-between align-items-center gap-3">
        <div>
            <button type="button" mat-dialog-close mat-raised-button color="warn">cancel</button>
        </div>
        <div>
            <button *ngIf="meetingStatusControl.value === 1" mat-raised-button color="primary"
                    [disabled]="meetingDateControl.invalid || meetingTimeControl.invalid"
                    (click)="updateMeetingResponseWithYes()">Update
            </button>
        </div>
    </div>
</div>


